import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class FormAgentService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.FORM_AGENT = '/api/form-agent';

        this.GET_BY_ID = '/{id}';
        this.GET_BY_FORM_ID = '/form/{formId}';
        this.GET_USER_BY_FORM_ID = '/form/user/{formId}';
        this.GET_BY_PROJECT_ID = '/project/{projectId}';
        this.GET_BY_USER_ID = '/user/{userId}';
        this.GET_FORM_IDS_BY_USER_ID = '/form-ids/user/{userId}';

    }

    async getById(id) {
        try {
            let url = window.location.origin + this.FORM_AGENT + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByForm(formId) {
        try {
            let url = window.location.origin + this.FORM_AGENT + this.GET_BY_FORM_ID;
            url = url
                .replace('{formId}', formId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getFormAgentUserListByFormId(formId) {
        try {
            let url = window.location.origin + this.FORM_AGENT + this.GET_USER_BY_FORM_ID;
            url = url
                .replace('{formId}', formId)
            const formAgentUserList = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return formAgentUserList;
        } catch (err) {
            console.log(err);
        }
    }

    async getByUserId(userId) {
        try {
            let url = window.location.origin + this.FORM_AGENT + this.GET_BY_USER_ID;
            url = url
                .replace('{userId}', userId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getFormIdsByUserId(userId) {
        try {
            let url = window.location.origin + this.FORM_AGENT + this.GET_FORM_IDS_BY_USER_ID;
            url = url
                .replace('{userId}', userId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByProject(projectId) {
        try {
            let url = window.location.origin + this.FORM_AGENT + this.GET_BY_PROJECT_ID;
            url = url
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async createFormAgent(formAgent) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.FORM_AGENT;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(formAgent)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateFormAgent(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.FORM_AGENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteFormAgent(deleteMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.FORM_AGENT;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default FormAgentService;
